<template>
    <div class="dml-scrollable-banners">
        <span v-if="name" class="dml-scrollable-banners__title"> {{name}} </span>
        <dm-scrollable-list className="dml-scrollable-banners__wrap"
                            innerClassName="dml-scrollable-banners__list"
                            navClassName="dml-scrollable-banners__nav"
                            :itemsInViewport="3">
            <template slot="items">
                <li v-for="banner in banners"
                    class="dml-scrollable-banners__item">
                    <a :href="banner.url"
                       class="dml-scrollable-banners__wrapper">
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAHCAQAAACBmfRmAAAAEUlEQVR42mNk+M8AB4xU5QAAXngHAZynWTMAAAAASUVORK5CYII="
                             :data-srcset="`${banner.mobileImageUrl} 328w,
                                          ${banner.imageUrl} 400w,
                                          ${banner.largeMobileImageUrl} 656w,
                                          ${banner.largeImageUrl} 800w`"
                             sizes="(max-width: 720px) 79.17vw,
                                    (max-width: 1280px) 38.67vw,
                                    400px"
                             :alt="banner.alt"
                             class="lazy" />
                    </a>
                </li>
            </template>
        </dm-scrollable-list>
    </div>
</template>
<script>
    import ScrollableListComponent from '../shared/scrollable-list-component.vue';

    export default {
        name: 'dm-scrollable-banners',
        components: {
            'dm-scrollable-list': ScrollableListComponent,
        },
        props: {
            name: {
                type: String,
                required: false
            },
            banners: {
                type: Array,
                required: true
            }
        },
    };
</script>
